import { render, staticRenderFns } from "./SponsoredRecommendation.vue?vue&type=template&id=0aa22bcb&scoped=true"
import script from "./SponsoredRecommendation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendation.vue?vue&type=style&index=0&id=0aa22bcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa22bcb",
  null
  
)

export default component.exports